<template>
  <ForgotPasswordBody2/>
</template>

<script>
// @ is an alias to /src
import ForgotPasswordBody2 from '@/components/ForgotPasswordBody2.vue'

export default {
  name: 'ForgotPasswordView2',
  components: {
    ForgotPasswordBody2
  }
}
</script>
